$(document).ready(function() {
    $(".dropdown").hover(
        function() { $(this).find('.dropdown-menu').addClass('show-mega-menu'); },
        function() { $(this).find('.dropdown-menu').removeClass('show-mega-menu'); }
    );
});